import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppointmentOrder from "./tabs/AppointmentOrder";
import { Wrapper } from "../styled";

const employmentOrederTabs = [
{
    title: "Приказ на прием",
    component: <AppointmentOrder/>,
}
];

const EmploymentOreder: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {employmentOrederTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {employmentOrederTabs[tab].component}
    </Wrapper>
);
};

export default EmploymentOreder;
